import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
const i = (o, t) => `${o}--${t}`, s = (o, t, n) => typeof n == "string" ? n.split(" ").map((r) => i(o, `${t}${r}`)).join(" ") : i(o, t), f = (o, t, n) => typeof t == "boolean" ? t ? i(o, n) : "" : s(o, n, t);
export {
  f as buildBooleanClass,
  i as modifyClassName,
  s as responsiveModifyClass
};
